import { useState } from "react";
import JoditEditor from "@nkr/components/editor";
import config from '../../ticketing/jodit-editor-config';
import { Panel } from "react-bootstrap";
import Switch from "react-switch";

interface IProps {
    value: string,
    onChange: (property: string, value: string) => void
}

const NetworkEmailSignature = ({ value, onChange }: IProps) => {
    const [expanded, setExpanded] = useState(true);

    const handleEditorChange = (e: string) => {
        onChange('emailSignature', e);
    }

    const editorConfig = { ...config, height: '300px' };

    return (
        <Panel expanded={expanded} onToggle={() => { }}>
            <Panel.Heading style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Network Email Signature Editor
                <Switch onChange={setExpanded} checked={expanded} height={20} width={40} uncheckedIcon={false} checkedIcon={false} />
            </Panel.Heading>
            <Panel.Collapse>
                <Panel.Body>
                    <JoditEditor
                        value={value}
                        config={editorConfig}
                        onChange={handleEditorChange}
                        onBlur={() => null}
                    />
                </Panel.Body>
            </Panel.Collapse>
        </Panel>
    );
}

export default NetworkEmailSignature;
